export default "__VITE_PUBLIC_ASSET__21958833__"